import React from "react";
import { BottomPoints, StylesForButtons } from "ComponentsUI/CarouselComponents";
import { BackgroundImage } from "ComponentsUI/BackgroundImage";
var Carousel = require("nuka-carousel");
import BenefitCarousel from "ComponentsUI/Benefit/Components/BenefitCarousel";
import { PaddingBottom } from "ComponentsUI/Spacings";
import withStyles from "react-jss";
import { inject } from "mobx-react";
import { webpSimpleTransformer } from "Helpers/ImageManager";

const styles = (theme) => {
	return {
		root: {
			position: "relative",
			"& .slider-decorator-0": {
				display: "none",
			},
		},
		wrapper: {
			position: "relative",
			paddingTop: "70px",
			paddingBottom: "70px",
		},
		header: {
			textAlign: "center",
			fontFamily: theme.fonts.bold,
			fontSize: "48px",
			lineHeight: 1,
			color: theme.palette.colors.white,
			paddingBottom: "40px",
		},
		layout: {
			position: "relative",
		},
		list: {
			marginLeft: "200px",
			marginRight: "180px",
			paddingTop: "40px",
			display: "flex",
			justifyContent: "space-between",
		},
		[`@media (min-width: ${theme.media.md}) and (max-width: ${theme.media.lg})`]: {
			list: {
				marginLeft: "80px",
				marginRight: 0,
			},
		},
		[`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
			wrapper: {
				paddingTop: "60px",
				paddingBottom: "60px",
			},
			header: {
				fontSize: "36px",
			},
			list: {
				marginLeft: 0,
				marginRight: 0,
			},
		},
		[`@media (max-width: ${theme.media.sm})`]: {
			root: {
				"& .slider-decorator-0": {
					display: "block",
					bottom: "-35px !important",
					"& button": {
						padding: "3px !important",
					},
				},
			},
			wrapper: {
				paddingTop: "35px",
				paddingBottom: "50px",
			},
			header: {
				fontSize: "24px",
				paddingBottom: "20px",
			},
			list: {
				marginLeft: 0,
				marginRight: 0,
				paddingTop: "40px",
			},
		},
	};
};

@inject("ApplicationModel")
class BenefitsWrapper extends React.Component {
	render() {
		const text = this.props.ApplicationModel.text;
		let classes = this.props.classes;
		let windowSizes = this.props.ApplicationModel.windowSizeModel.windowSizes;
		let decorator = [
			{
				component: (props) => (
					<BottomPoints {...props} getButtonStyles={StylesForButtons.greenPoints} />
				),
				position: "BottomCenter",
			},
		];
		return (
			<PaddingBottom>
				<div className={classes.root}>
					<div className={classes.wrapper}>
						<BackgroundImage
							webpTransformer={webpSimpleTransformer}
							background={this.props.imageBenefit}
							windowSizes={windowSizes}
						/>
						<div className={classes.header}>{text.BENEFITS_TITLE}</div>
						<div className={"onlyNotXs"}>
							<div className={classes.layout} datatest={this.props.datatest}>
								<div className="container">
									<div className={classes.list}>
										<BenefitCarousel
											header={text.TITLE_TEST_DRIVE}
											text={text.TEXT_GARANTY}
											icon={
												<span
													style={{
														fontSize: "24px",
														color: "#ccff00",
													}}
													className="icon24 icon-laptop-1"
												/>
											}
										/>
										<BenefitCarousel
											header={text.TITLE_HIGH_SPEED_LOW_PAY}
											text={text.TEXT_HIGH_SPEED_LOW_PAY}
											icon={
												<span
													style={{
														fontSize: "24px",
														color: "#ccff00",
													}}
													className="icon24 icon-swap-vertical"
												/>
											}
										/>
										<BenefitCarousel
											header={text.TITLE_NO_OVERPAY}
											text={text.TEXT_NO_OVERPAY}
											icon={
												<span
													style={{
														fontSize: "24px",
														color: "#ccff00",
													}}
													className="icon24 icon-calendar-date"
												/>
											}
										/>
									</div>
								</div>
							</div>
						</div>
						<div className={"onlyXs"}>
							<Carousel
								wrapAround={true}
								needRecalculateHeight={true}
								heightMode="max"
								decorators={decorator}
							>
								<div className={classes.layout}>
									<div className="container">
										<div className={classes.list}>
											<BenefitCarousel
												header={text.TITLE_TEST_DRIVE}
												text={text.TEXT_GARANTY}
												icon={
													<span
														style={{
															fontSize: "24px",
															color: "#ccff00",
														}}
														className="icon24 icon-laptop-1"
													/>
												}
											/>
										</div>
									</div>
								</div>
								<div className={classes.layout}>
									<div className="container">
										<div className={classes.list}>
											<BenefitCarousel
												header={text.TITLE_HIGH_SPEED_LOW_PAY}
												text={text.TEXT_HIGH_SPEED_LOW_PAY}
												icon={
													<span
														style={{
															fontSize: "24px",
															color: "#ccff00",
														}}
														className="icon24 icon-swap-vertical"
													/>
												}
											/>
										</div>
									</div>
								</div>
								<div className={classes.layout}>
									<div className="container">
										<div className={classes.list}>
											<BenefitCarousel
												header={text.TITLE_NO_OVERPAY}
												text={text.TEXT_NO_OVERPAY}
												icon={
													<span
														style={{
															fontSize: "24px",
															color: "#ccff00",
														}}
														className="icon24 icon-calendar-date"
													/>
												}
											/>
										</div>
									</div>
								</div>
							</Carousel>
						</div>
					</div>
				</div>
			</PaddingBottom>
		);
	}
}

export default withStyles(styles)(BenefitsWrapper);
